var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconQuizz = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ico-quizz",
    width: 20.783,
    height: 24,
    viewBox: "0 0 20.783 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ico-quizz .a{fill:none;}.ico-quizz .b{clip-path:url(#a);}.ico-quizz .c{fill:#e4eaf2;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20.783,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M33.623,39.7H27.146l-.167-2.379a6.6,6.6,0,1,1,6.81.269Zm-5.906-.611h5.342l.149-1.883.151-.078a5.992,5.992,0,1,0-5.923-.24l.132.082Z",
    transform: "translate(-20.336 -21.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M48.534,120.666H46.42a1.782,1.782,0,0,1-1.861-1.433l-.381-3.166h6.6l-.381,3.166a1.782,1.782,0,0,1-1.861,1.433m-3.667-3.987.3,2.481a1.193,1.193,0,0,0,1.254.895h2.114a1.193,1.193,0,0,0,1.254-.895l.3-2.481Z",
    transform: "translate(-37.427 -98.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.514,143.858h-1.38c-.193,0-1.163-.026-1.31-.538l-.334-1.16h4.669l-.334,1.16c-.148.513-1.117.538-1.31.538m-2.115-.747a1.587,1.587,0,0,0,.734.136h1.38a1.588,1.588,0,0,0,.735-.136l.1-.34H51.3Z",
    transform: "translate(-42.774 -120.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.147,149.944l.222.77c.052.18.491.317,1.017.317h1.38c.525,0,.965-.137,1.017-.317l.222-.77Z",
    transform: "translate(-45.026 -127.032)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M70.093,43.978a.306.306,0,0,1-.306-.306,4.268,4.268,0,0,0-4.263-4.263.306.306,0,0,1,0-.611A4.88,4.88,0,0,1,70.4,43.672a.306.306,0,0,1-.306.306",
    transform: "translate(-55.253 -32.869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M65.525,2.812a.306.306,0,0,1-.306-.306V.306a.306.306,0,0,1,.611,0v2.2a.306.306,0,0,1-.306.306",
    transform: "translate(-55.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M23.284,20.959a.3.3,0,0,1-.216-.09l-1.556-1.556a.306.306,0,0,1,.432-.432L23.5,20.437a.306.306,0,0,1-.216.522",
    transform: "translate(-18.149 -15.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.506,63.658H.306a.306.306,0,0,1,0-.611h2.2a.306.306,0,0,1,0,.611",
    transform: "translate(0 -53.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M120.112,62.088h-2.2a.306.306,0,1,1,0-.611h2.2a.306.306,0,0,1,0,.611",
    transform: "translate(-99.634 -52.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M99.6,19.848a.306.306,0,0,1-.216-.522l1.556-1.556a.306.306,0,0,1,.432.432l-1.556,1.556a.3.3,0,0,1-.216.09",
    transform: "translate(-84.118 -14.979)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconQuizz, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_quizz.30e5c6b5.svg";
export { ForwardRef as ReactComponent };